import React, { Component } from 'react';
import {NavDropdown, MenuItem } from 'react-bootstrap';

export class HeaderBar extends Component {

    changeView = (e) => {
      this.props.onChangeView(e);
    }

    linkLogin = () => {
      this.props.onChangeView('login');
    }

    render() {
        return(

                <div className="row border-bottom white-bg">
                  <nav className="navbar navbar-static-top" >
                      <div className="navbar-header">
                          <button aria-controls="navbar" aria-expanded="false" data-target="#navbar" data-toggle="collapse" className="navbar-toggle collapsed" type="button">
                              <i className="fa fa-reorder"></i>
                          </button>

                          <a className="navbar-brand logo">
                          <img src="/img/nxxt-logo.png" className="img-responsive nxxt-logo" />
                          NXXT
                          </a>
                      </div>
                      <div className="navbar-collapse collapse" id="navbar">
                          <ul className="nav navbar-nav" >

                          <NavDropdown eventKey={3} title="Select View" id="basic-nav-dropdown">
                            <MenuItem eventKey={'dashboard'} onSelect={this.changeView}>Main Dashboard</MenuItem>
                            <MenuItem eventKey={'logisticcreator'} onSelect={this.changeView}>Shipper RFQ</MenuItem>
                            <MenuItem eventKey={'truckdispatcher'} onSelect={this.changeView}>Carrier View</MenuItem>
                            <MenuItem eventKey={'recipientapp'} onSelect={this.changeView}>Recipient App View</MenuItem>
                            <MenuItem eventKey={'truckerapp'} onSelect={this.changeView}>Trucker App View</MenuItem>
                          </NavDropdown>

                          </ul>
                          <ul className="nav navbar-top-links navbar-right">
                              <li>
                                  <a onClick={this.linkLogin}>
                                      <i className="fa fa-sign-out"></i> Log out
                                  </a>
                              </li>
                          </ul>
                      </div>
                  </nav>


                  <div className="btn-group btn-breadcrumb breadcrumb-default">
                      <a  className="btn btn-default"><i className="glyphicon glyphicon-home"></i></a>

                      <a  className="btn btn-default visible-lg-block visible-md-block">{this.props.actualPosition}</a>
                  </div>

                </div>

        );
    }
};



// WEBPACK FOOTER //
// ./src/components/HeaderBar.js